import http from "./http.js";
import moment from "moment";
moment.locale("uk");

async function fetchAll(page = 1, pageSize = 9, dateFrom, dateTo, syncOperationFinished) {
  try {
    const response = await http.get("sync-operations", {
      params: {
        page,
        pageSize,
        "filter.startedAt": dateFrom ? dateFrom : "",
        "filter.finishedAt": dateTo ? dateTo : "",
        "filter.SyncOperationFinished": syncOperationFinished ? syncOperationFinished : "",
        "Order.StartedAt.IsDesc": true,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function syncData(date) {
  const from = moment(date).format("YYYY-MM-DD");
  try {
    await http.post(`rpc/sync-worklogs?from=${from}`);
  } catch (err) {
    throw err;
  }
}

export {
  fetchAll,
  syncData,
};
